import { OrderedLayers } from './constants.js';

// The z-index is dictated by the position of a layer in the OrderedLayers array
// We increment it by 1 so the first z-index used is 1 and not 0
var getZIndexFromLayer = function getZIndexFromLayer(layer) {
  var index = OrderedLayers.indexOf(layer);

  if (index >= 0) {
    return index + 1;
  }

  return 0;
};

export { getZIndexFromLayer };
